const DIFM_BANNER_CLOSED_BY_USER = 'isDifmBannerClosedByUser';

export const getDifmBannerSessionStorageValue = () =>
  sessionStorage.getItem(DIFM_BANNER_CLOSED_BY_USER);

export const setDifmBannerSessionStorageValue = (userId) =>
  sessionStorage.setItem(DIFM_BANNER_CLOSED_BY_USER, userId);
